import { styled } from "@mui/material";

export const MainWithFooterStyles = styled("main")`
  flex: 1 1 100%;
  display: flex;
  overflow: hidden;
  justify-content: stretch;
  height: fit-content;

  .leaflet-container {
    flex: 1 1 100%;
  }
`;
